import React, { memo, useRef, useState } from 'react';
import { ArrowUp } from 'lucide-react';
import { ui } from '../ui';

// Uncontrolled input: typing never re-renders the grid, and remote updates
// never touch its value, so focus and in-progress text are always preserved.
// The visible Add button exists because "just press Enter" was not discoverable
//, especially on phones, where the keyboard's return key is easy to miss.
const InputField = memo(function InputField({ placeholder, onSubmit }) {
  const inputRef = useRef(null);
  const [hasText, setHasText] = useState(false);

  const submit = () => {
    const el = inputRef.current;
    const value = (el?.value || '').trim();
    if (!value) return;
    onSubmit(value);
    el.value = '';
    setHasText(false);
    el.focus();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      submit();
    }
  };

  return (
    <div className="relative">
      <input
        ref={inputRef}
        type="text"
        placeholder={placeholder}
        aria-label={placeholder}
        enterKeyHint="done"
        className={`${ui.input} pr-10`}
        onKeyDown={handleKeyDown}
        onInput={(e) => setHasText(!!e.target.value.trim())}
      />
      <button
        type="button"
        onClick={submit}
        disabled={!hasText}
        title="Add (or press Enter)"
        aria-label={`Add, ${placeholder}`}
        className={`absolute right-1 top-1/2 -translate-y-1/2 w-7 h-7 rounded-ctl flex items-center justify-center transition-colors ${
          hasText ? 'bg-accent text-white hover:bg-accent-strong' : 'text-ink-2/60'
        }`}
      >
        <ArrowUp className="w-4 h-4" />
      </button>
    </div>
  );
});

export default InputField;
